// External libraries
import styled from '@emotion/styled';
import { css } from '@emotion/core';

// Internal modules
import {
  DISABLED_BACKGROUND_COLOR,
  DISABLED_BORDER_COLOR,
  ERROR_COLOR,
  HEADER_COLOR,
  WHITE_COLOR,
} from '@/styles';
import { LABEL_COLOR } from '@/styles/styleVariables';

const containerStyles = css`
  background-color: ${DISABLED_BACKGROUND_COLOR};
  border-color: ${DISABLED_BORDER_COLOR};

  > select {
    color: ${HEADER_COLOR};
  }
`;

const tooltipErrorStyle = css`
  background-color: ${ERROR_COLOR};
  border: 0;
  color: ${WHITE_COLOR};
  font-size: 15px;
  font-weight: 400;
  max-width: 100%;
  position: relative;
`;

const HelperText = styled.p`
  color: ${LABEL_COLOR};
  font-size: 14px;
  font-weight: normal;
  line-height: 1.2;
  margin: -10px 0 12px;
  white-space: normal;
`;

export { containerStyles, HelperText, tooltipErrorStyle };
